// Словарь сокращений для длинных названий команд
const TEAM_ABBREVIATIONS = {
  // Популярные команды с длинными названиями
  'Paris Saint Germain': 'PSG',
  'Paris Saint-Germain': 'PSG',
  'Internazionale Milano': 'Inter',
  'Inter Milan': 'Inter',
  'Borussia Dortmund': 'Dortmund',
  'Borussia Monchengladbach': 'Gladbach',
  'Manchester United': 'Man United',
  'Manchester City': 'Man City',
  'Atletico Madrid': 'Atletico',
  'Atlético Madrid': 'Atletico Madrid',
  'Bayern Munich': 'Bayern',
  'Tottenham Hotspur': 'Tottenham',
  'Leicester City': 'Leicester',
  'Brighton & Hove Albion': 'Brighton',
  'Crystal Palace': 'Palace',
  'Sheffield United': 'Sheffield Utd',
  'West Ham United': 'West Ham',
  'Newcastle United': 'Newcastle',
  'Aston Villa': 'Villa',
  'Wolverhampton Wanderers': 'Wolves',
  'Norwich City': 'Norwich',
  'Burnley': 'Burnley',
  'Watford': 'Watford',
  'Southampton': 'Southampton',
  'Everton': 'Everton',
  'Liverpool': 'Liverpool',
  'Arsenal': 'Arsenal',
  'Chelsea': 'Chelsea',
  'Fulham': 'Fulham',
  'Brighton and Hove Albion': 'Brighton',
  'Bayer Leverkusen': 'Leverkusen',
  'RB Leipzig': 'Leipzig',
  'SC Freiburg': 'Freiburg',
  'TSG Hoffenheim': 'Hoffenheim',
  '1. FSV Mainz 05': 'Mainz',
  'VfL Wolfsburg': 'Wolfsburg',
  'VfL Bochum': 'Bochum',
  'FC Augsburg': 'Augsburg',
  '1. FC Union Berlin': 'Union Berlin',
  '1. FC Heidenheim': 'Heidenheim',
  'Holstein Kiel': 'Holstein Kiel',
  'FC St. Pauli': 'St. Pauli',
  'VfB Stuttgart': 'Stuttgart',
  'Eintracht Frankfurt': 'Eintracht',
  'Celta Vigo': 'Celta',
  'Athletic Club': 'Athletic',
  'Alavés': 'Alavés',
  'Getafe CF': 'Getafe',
  'Girona FC': 'Girona',
  'Rayo Vallecano': 'Rayo Vallecano',
  'Real Betis Balompié': 'Real Betis',
  'Real Sociedad de Fútbol': 'Real Sociedad',
  'Sevilla FC': 'Sevilla',
  'Valencia CF': 'Valencia',
  'Villarreal CF': 'Villarreal',
  'CA Osasuna': 'Osasuna',
  'RCD Mallorca': 'Mallorca',
  'UD Las Palmas': 'Las Palmas',
  'CD Leganés': 'Leganes',
  'Cádiz CF': 'Cadiz',
  'Granada CF': 'Granada',
  'Levante UD': 'Levante',
  'Real Valladolid': 'Valladolid',
  'Espanyol': 'Espanyol',
  'AC Milan': 'AC Milan',
  'Atalanta BC': 'Atalanta',
  'Bologna FC 1909': 'Bologna',
  'Cagliari Calcio': 'Cagliari',
  'Como 1907': 'Como',
  'Empoli FC': 'Empoli',
  'ACF Fiorentina': 'Fiorentina',
  'Genoa CFC': 'Genoa',
  'Hellas Verona FC': 'Verona',
  'Juventus FC': 'Juventus',
  'SS Lazio': 'Lazio',
  'US Lecce': 'Lecce',
  'AC Monza': 'Monza',
  'SSC Napoli': 'Napoli',
  'Parma Calcio 1913': 'Parma',
  'AS Roma': 'Roma',
  'Torino FC': 'Torino',
  'Udinese Calcio': 'Udinese',
  'Venezia FC': 'Venezia',
  'AJ Auxerre': 'Auxerre',
  'Angers SCO': 'Angers',
  'Stade Brestois 29': 'Brest',
  'Le Havre AC': 'Le Havre',
  'RC Lens': 'Lens',
  'LOSC Lille': 'Lille',
  'Olympique Lyonnais': 'Lyon',
  'Olympique de Marseille': 'Marseille',
  'FC Metz': 'Metz',
  'AS Monaco FC': 'Monaco',
  'Montpellier HSC': 'Montpellier',
  'FC Nantes': 'Nantes',
  'OGC Nice': 'Nice',
  'Stade de Reims': 'Reims',
  'Stade Rennais FC': 'Rennes',
  'AS Saint-Étienne': 'Saint-Étienne',
  'RC Strasbourg Alsace': 'Strasbourg',
  'Toulouse FC': 'Toulouse',
  'USL Dunkerque': 'Dunkerque',
  'PSV Eindhoven': 'PSV',
  'FC Twente': 'Twente',
  'FC Utrecht': 'Utrecht',
  'FC Groningen': 'Groningen',
  'FC Eindhoven': 'Eindhoven',
  'FC Den Bosch': 'Den Bosch',
  'FC Dordrecht': 'Dordrecht',
  'FC Volendam': 'Volendam',
  'FC Zwolle': 'Zwolle',
  'FC Emmen': 'Emmen',
  'AVS Futebol SAD': 'AFS',
  'FC Porto': 'Porto',
  'FC Braga': 'Braga',
  'FC Lisbon': 'Lisbon',
  'NAC Breda': 'Breda',
  'West Bromwich Albion': 'West Brom',
  'West Brom': 'West Brom',
  'Blackburn Rovers': 'Blackburn',

  // --- Добавлено: альтернативные лиги ---
  // Eredivisie
  'AFC Ajax': 'Ajax',
  'Feyenoord': 'Feyenoord',
  'AZ Alkmaar': 'AZ',
  'SC Heerenveen': 'Heerenveen',
  'Vitesse': 'Vitesse',
  'NEC Nijmegen': 'NEC',
  'Sparta Rotterdam': 'Sparta',
  'RKC Waalwijk': 'RKC',
  'Heracles Almelo': 'Heracles',
  'Go Ahead Eagles': 'Go Ahead',
  'Fortuna Sittard': 'Fortuna',
  'PEC Zwolle': 'Zwolle',
  'Almere City FC': 'Almere City',
  'SBV Excelsior': 'Excelsior',
  'ADO Den Haag': 'Den Haag',
  'SC Cambuur': 'Cambuur',
  'De Graafschap': 'Graafschap',

  // EFL Championship
  'Leeds United': 'Leeds',
  'Ipswich Town': 'Ipswich',
  'Middlesbrough': 'Middlesbrough',
  'Sunderland': 'Sunderland',
  'Stoke City': 'Stoke',
  'Swansea City': 'Swansea',
  'Coventry City': 'Coventry',
  'Hull City': 'Hull',
  'Bristol City': 'Bristol City',
  'Cardiff City': 'Cardiff',
  'Queens Park Rangers': 'QPR',
  'Plymouth Argyle': 'Plymouth',
  'Rotherham United': 'Rotherham',
  'Sheffield Wednesday': 'Sheff Wed',
  'Preston North End': 'Preston',
  'Millwall': 'Millwall',
  'Huddersfield Town': 'Huddersfield',
  'Birmingham City': 'Birmingham',

  // Portugal Primeira Liga
  'SL Benfica': 'Benfica',
  'Sporting CP': 'Sporting',
  'Sporting Lisbon': 'Sporting',
  'Vitória SC': 'Vitoria',
  'Vitoria Guimaraes': 'Vitoria',
  'Boavista FC': 'Boavista',
  'Rio Ave FC': 'Rio Ave',
  'FC Famalicão': 'Famalicao',
  'GD Chaves': 'Chaves',
  'FC Arouca': 'Arouca',
  'Portimonense SC': 'Portimonense',
  'Gil Vicente FC': 'Gil Vicente',
  'Estoril Praia': 'Estoril',
  'FC Vizela': 'Vizela',
  'Casa Pia AC': 'Casa Pia',
  'SC Farense': 'Farense',
  'Estrela Amadora': 'Estrela',
  'Moreirense FC': 'Moreirense',

  // Ireland Premier Division
  'Shamrock Rovers': 'Shamrock',
  "St Patrick's Athletic": "St Pat's",
  'Bohemians': 'Bohemians',
  'Sligo Rovers': 'Sligo',
  'Shelbourne': 'Shelbourne',
  'Waterford': 'Waterford',
  'Drogheda United': 'Drogheda',
  'Galway United': 'Galway',

  // Coppa Italia (дополнительно)
  'Frosinone': 'Frosinone',
  'Sassuolo': 'Sassuolo',
  'Spezia': 'Spezia',
  'Cremonese': 'Cremonese',
  'Salernitana': 'Salernitana',
  'Brescia': 'Brescia',
  'Catania': 'Catania',
  'Bari': 'Bari',
  'Palermo': 'Palermo'
};

// Словарь маппинга названий команд к файлам логотипов
const TEAM_LOGO_MAPPING = {
  // Основные маппинги на основе реальных файлов
  'Paris Saint Germain': 'PSG',  // PSG.png
  'Paris Saint-Germain': 'PSG',
  'Internazionale Milano': 'Inter',  // Inter.png
  'Inter Milan': 'inter-milan',  // inter-milan.png
  'Manchester United': 'manchester-united',  // manchester-united.png
  'Manchester City': 'man-city',  // man-city.png
  'West Ham United': 'west-ham',  // west-ham.png
  'Newcastle United': 'Newcastle',  // Newcastle.png
  'Wolverhampton Wanderers': 'Wolves',
  'Young Boys': 'young-boys',
  'Union Berlin': 'union-berlin',
  'Werder Bremen': 'werder-bremen',
  'Willem II': 'willem-ii',
  'West Brom': 'west-brom',
  'Western Sydney': 'western-sydney',
  'Wellington Phoenix': 'wellington-phoenix',
  'Vancouver Whitecaps': 'vancouver-whitecaps',
  'Vasco Da Gama': 'vasco-da-gama',
  'Viktoria Plzen': 'viktoria-plzen',
  'Zorya Lugansk': 'zorya-lugansk',
  'Zarya Lugansk': 'zarya-lugansk',
  'Athletic Bilbao': 'athletic-bilbao',
  'Atletico Madrid': 'atletico-madrid',
  'Atlético Madrid': 'atletico-madrid',
  'Real Madrid': 'real-madrid',  // real-madrid.png
  'Barcelona': 'Barcelona',  // Barcelona.png
  'Bayern Munich': 'bayern-munich',  // bayern-munich.png
  'Borussia Dortmund': 'Dortmund',  // Dortmund.png
  'Borussia Mönchengladbach': 'Monchengladbach',
  'Eintracht Frankfurt': 'eintracht-frankfurt',
  'Hertha Berlin': 'hertha-berlin',
  'Liverpool': 'Liverpool',  // Liverpool.png
  'Arsenal': 'Arsenal',  // Arsenal.png
  'Chelsea': 'Chelsea',  // Chelsea.png
  'Fulham': 'Fulham',  // Fulham.png
  'Everton': 'Everton',  // Everton.png
  'Aston Villa': 'aston-villa',  // aston-villa.png
  'Southampton': 'Southampton',  // Southampton.png
  'Bayer 04 Leverkusen': 'bayer-leverkusen',
  'RB Leipzig': 'Leipzig',
  'SC Freiburg': 'Freiburg',
  'TSG Hoffenheim': 'Hoffenheim',
  '1. FSV Mainz 05': 'Mainz',
  'VfL Wolfsburg': 'Wolfsburg',
  'VfL Bochum': 'Bochum',
  'FC Augsburg': 'Augsburg',
  '1. FC Union Berlin': 'union-berlin',
  '1. FC Heidenheim': 'Heidenheim',
  'FC St. Pauli': 'st-pauli',
  'VfB Stuttgart': 'Stuttgart',
  'Athletic Club': 'athletic-club',
  'Alavés': 'deportivo-alaves',
  'Getafe CF': 'Getafe',
  'Girona FC': 'Girona',
  'Rayo Vallecano': 'rayo-vallecano',
  'Real Betis Balompié': 'real-betis',
  'Real Sociedad de Fútbol': 'real-sociedad',
  'Sevilla FC': 'Sevilla',
  'Valencia CF': 'Valencia',
  'Villarreal CF': 'Villarreal',
  'CA Osasuna': 'Osasuna',
  'RCD Mallorca': 'Mallorca',
  'UD Las Palmas': 'las-palmas',
  'CD Leganés': 'Leganes',
  'Cádiz CF': 'Cadiz',
  'Granada CF': 'Granada',
  'Levante UD': 'Levante',
  'Real Valladolid': 'real-valladolid',
  'Espanyol': 'Espanyol',
  'AC Milan': 'ac-milan',
  'Atalanta BC': 'Atalanta',
  'Bologna FC 1909': 'Bologna',
  'Cagliari Calcio': 'Cagliari',
  'Como 1907': 'Como',
  'Empoli FC': 'Empoli',
  'ACF Fiorentina': 'Fiorentina',
  'Genoa CFC': 'Genoa',
  'Hellas Verona FC': 'Verona',
  'Juventus FC': 'Juventus',
  'SS Lazio': 'Lazio',
  'US Lecce': 'Lecce',
  'AC Monza': 'Monza',
  'SSC Napoli': 'Napoli',
  'Parma Calcio 1913': 'Parma',
  'AS Roma': 'Roma',
  'Torino FC': 'Torino',
  'Udinese Calcio': 'Udinese',
  'Venezia FC': 'Venezia',
  'AJ Auxerre': 'Auxerre',
  'Angers SCO': 'Angers',
  'Stade Brestois 29': 'Brest',
  'Le Havre AC': 'le-havre',
  'RC Lens': 'Lens',
  'LOSC Lille': 'Lille',
  'Olympique Lyonnais': 'Lyon',
  'Olympique de Marseille': 'Marseille',
  'FC Metz': 'Metz',
  'AS Monaco FC': 'Monaco',
  'Montpellier HSC': 'Montpellier',
  'FC Nantes': 'Nantes',
  'OGC Nice': 'Nice',
  'Stade de Reims': 'Reims',
  'Stade Rennais FC': 'Rennes',
  'AS Saint-Étienne': 'saint-etienne',
  'RC Strasbourg Alsace': 'Strasbourg',
  'Toulouse FC': 'Toulouse',
  'USL Dunkerque': 'Dunkerque',
  'PSV Eindhoven': 'PSV',
  'FC Twente': 'Twente',
  'FC Utrecht': 'Utrecht',
  'FC Groningen': 'Groningen',
  'FC Eindhoven': 'Eindhoven',
  'FC Den Bosch': 'Den Bosch',
  'FC Dordrecht': 'Dordrecht',
  'FC Volendam': 'Volendam',
  'FC Zwolle': 'Zwolle',
  'FC Emmen': 'Emmen',
  'AVS Futebol SAD': 'AFS',
  'FC Porto': 'Porto',
  'FC Braga': 'Braga',
  'FC Lisbon': 'Lisbon',
  'NAC Breda': 'Breda',
  'Sheffield United': 'Sheffield Utd',
  'West Bromwich Albion': 'West Brom',
  'Blackburn Rovers': 'Blackburn',

  // --- Добавлено: альтернативные лиги ---
  // Eredivisie
  'AFC Ajax': 'Ajax',
  'AZ Alkmaar': 'az-alkmaar',
  'SC Heerenveen': 'Heerenveen',
  'Vitesse': 'Vitesse',
  'NEC Nijmegen': 'NEC',
  'Sparta Rotterdam': 'Sparta',
  'RKC Waalwijk': 'RKC',
  'Heracles Almelo': 'Heracles',
  'Go Ahead Eagles': 'go-ahead-eagles',
  'Fortuna Sittard': 'Fortuna',
  'PEC Zwolle': 'Zwolle',
  'Almere City FC': 'almere-city',
  'SBV Excelsior': 'excelsior',
  'ADO Den Haag': 'den-haag',
  'SC Cambuur': 'cambuur',
  'De Graafschap': 'de-graafschap',

  // EFL Championship
  'Leeds United': 'Leeds',
  'Ipswich Town': 'ipswich-town',
  'Middlesbrough': 'middlesbrough',
  'Sunderland': 'Sunderland',
  'Stoke City': 'stoke-city',
  'Swansea City': 'swansea-city',
  'Coventry City': 'coventry-city',
  'Hull City': 'hull-city',
  'Bristol City': 'bristol-city',
  'Cardiff City': 'cardiff-city',
  'Queens Park Rangers': 'queens-park-rangers',
  'Plymouth Argyle': 'plymouth-argyle',
  'Rotherham United': 'rotherham-united',
  'Sheffield Wednesday': 'sheffield-wednesday',
  'Preston North End': 'preston',
  'Millwall': 'Millwall',
  'Huddersfield Town': 'huddersfield-town',
  'Birmingham City': 'birmingham-city',

  // Portugal Primeira Liga
  'SL Benfica': 'Benfica',
  'Sporting CP': 'sporting',
  'Sporting Lisbon': 'sporting',
  'Vitória SC': 'vitoria-sc',
  'Vitoria Guimaraes': 'vitoria-sc',
  'Boavista FC': 'Boavista',
  'Rio Ave FC': 'rio-ave',
  'FC Famalicão': 'famalicao',
  'GD Chaves': 'Chaves',
  'FC Arouca': 'Arouca',
  'Portimonense SC': 'portimonense',
  'Gil Vicente FC': 'gil-vicente',
  'Estoril Praia': 'Estoril',
  'FC Vizela': 'Vizela',
  'Casa Pia AC': 'casa-pia',
  'SC Farense': 'Farense',
  'Estrela Amadora': 'estrela-amadora',
  'Moreirense FC': 'Moreirense',

  // Ireland Premier Division
  'Shamrock Rovers': 'shamrock-rovers',
  "St Patrick's Athletic": 'st-patricks-athletic',
  'Bohemians': 'Bohemians',
  'Sligo Rovers': 'sligo-rovers',
  'Shelbourne': 'Shelbourne',
  'Waterford': 'Waterford',
  'Drogheda United': 'drogheda-united',
  'Galway United': 'galway-united',

  // Coppa Italia (дополнительно)
  'Frosinone': 'Frosinone',
  'Sassuolo': 'Sassuolo',
  'Spezia': 'Spezia',
  'Cremonese': 'Cremonese',
  'Salernitana': 'Salernitana',
  'Brescia': 'Brescia',
  'Catania': 'Catania',
  'Bari': 'Bari',
  'Palermo': 'Palermo'
};

/**
 * Получает сокращенное название команды для мобильных устройств
 * @param {string} teamName - Полное название команды
 * @returns {string} - Сокращенное название или оригинальное
 */
export const getTeamAbbreviation = (teamName) => {
  return TEAM_ABBREVIATIONS[teamName] || teamName;
};

/**
 * Генерирует массив возможных путей к логотипу команды
 * @param {string} teamName - Название команды
 * @returns {string[]} - Массив возможных путей
 */
export const getTeamLogoPaths = (teamName) => {
  if (!teamName || typeof teamName !== 'string') {
    return ['/teams/default.png'];
  }

  const paths = [];
  
  // 1. Специальный маппинг (приоритет)
  const mappedName = TEAM_LOGO_MAPPING[teamName];
  if (mappedName) {
    paths.push(`/teams/${mappedName}.png`);
  }
  
  // 2. Точное совпадение с URL-кодированием
  paths.push(`/teams/${encodeURIComponent(teamName)}.png`);
  
  // 3. Kebab-case (самый популярный формат)
  const kebabCase = teamName.toLowerCase().replace(/\s+/g, '-');
  if (kebabCase !== teamName.toLowerCase()) {
    paths.push(`/teams/${kebabCase}.png`);
  }
  
  // 4. Первое слово (только если больше 3 символов)
  const firstWord = teamName.split(' ')[0];
  if (firstWord && firstWord !== teamName && firstWord.length > 3) {
    paths.push(`/teams/${firstWord}.png`);
  }
  
  // 5. Fallback
  paths.push('/teams/default.png');
  
  // Убираем дубликаты
  return [...new Set(paths)];
}; 